import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { maintenanceService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { MaintenanceColumns } from 'components/common/enhanced/common-headers';
import { Button, ButtonGroup } from '@mui/material';
import { Link } from 'react-router-dom';
import CloseMaintenanceDialog from './CloseMaintenanceDialog';
import { IMaintenance } from 'interfaces';

export const ExpiringMaintenances = () => {
  const translationPrefix = 'pages.maintenance-expiring';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [open, setOpen] = useState(false);
  const [maintenanceToClose, setMaintenanceToClose] = useState<IMaintenance | null>(null);

  const setOpenDialog = (row: IMaintenance) => {
    setOpen(true);
    setMaintenanceToClose(row);
  };

  const setCloseDialog = () => {
    setOpen(false);
    setMaintenanceToClose(null);
  };

  const columns: GridColDef[] = MaintenanceColumns(setOpenDialog, false, false, true);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <Link to="without-date" className="no-underline">
                <Button variant="outlined" size="small">
                  {t(`${translationPrefix}.button-without-date`)}
                </Button>
              </Link>
            </ButtonGroup>
          </div>
        }>
        <EnhancedDataGrid
          columns={columns}
          service={maintenanceService}
          getMethod={maintenanceService.getExpiringMaintenances}
          refresh={datagridRefresh}
        />
        <CloseMaintenanceDialog
          closeDialog={setCloseDialog}
          datagridRefresh={datagridRefresh}
          id={maintenanceToClose?.id}
          maintenance={maintenanceToClose}
          open={open}
        />
      </TenantPage>
    </>
  );
};

export default ExpiringMaintenances;
